import { render } from "./ItemWithKeywordNew.vue?vue&type=template&id=6f83e456&scoped=true&lang=pug"
import script from "./ItemWithKeywordNew.vue?vue&type=script&lang=js"
export * from "./ItemWithKeywordNew.vue?vue&type=script&lang=js"

import "./ItemWithKeywordNew.vue?vue&type=style&index=0&id=6f83e456&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f83e456"]])

export default __exports__